import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Layout, Icon, Menu, Row, Col, Dropdown } from 'antd';
import { logout } from '../../modules/auth';
import Navigation from '../../components/Navigation';
import logo from '../../assets/images/logo.png';
import './Layout.css';

const { Header, Sider, Content } = Layout;

class MainLayout extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    user: PropTypes.object,
    logout: PropTypes.func.isRequired,
  };

  state = {
    collapsed: false,
  };

  // eslint-disable-next-line
  styles = {
    divMenu: {
      minWidth: '14px',
      cursor: 'pointer',
    },
    menuIcon: {
      marginRight: '10px',
    },
  };

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  get title() {
    const location = this.props.location.pathname;
    const titles = [
      { regex: /\/dashboard$/i, name: 'Dashboard' },
      { regex: /\/admins$/i, name: 'Admins' },
      { regex: /\/clients$/i, name: 'Clients' },
      { regex: /\/categories$/i, name: 'Categories' },
      { regex: /\/types$/i, name: 'Types' },
      { regex: /\/cards$/i, name: 'Cards' },
      { regex: /\/places$/i, name: 'Places' },
      { regex: /\/reports$/i, name: 'Reports' },
      { regex: /\/admins\/new$/i, name: 'New Admin' },
      { regex: /\/categories\/new$/i, name: 'New Category' },
      { regex: /\/types\/new$/i, name: 'New Type' },
      { regex: /\/cards\/new$/i, name: 'New Card' },
      { regex: /\/places\/new$/i, name: 'New Place' },
      { regex: /\/admins\/[0-9]+$/i, name: 'Edit Admin' },
      { regex: /\/clients\/[0-9]+$/i, name: 'Client Information' },
      { regex: /\/categories\/[0-9]+$/i, name: 'Edit Category' },
      { regex: /\/types\/[0-9]+$/i, name: 'Edit Type' },
      { regex: /\/cards\/[0-9]+$/i, name: 'Edit Card' },
      { regex: /\/places\/[0-9]+$/i, name: 'Edit Place' },
      { regex: /\/reports\/[0-9]+$/i, name: 'Report Details' },
      { regex: /\/claim-business\/request$/i, name: 'Claim Business Requests' },
      { regex: /\/claim-business\/request\/[0-9]+$/i, name: 'Claim Business Request' },
    ];
    const title = titles.find(t => t.regex.test(location)) || { name: 'not found' };

    return title.name;
  }

  render() {
    return (
      <Layout className="layout">
        <Sider
          trigger={null}
          collapsible
          collapsed={this.state.collapsed}
          collapsedWidth={100}
        >
          <div className="logo">
            <img src={logo} alt="logo" />
          </div>
          <Navigation />
        </Sider>
        <Layout>
          <Header className="header">
            <Row
              type="flex"
              justify="space-between"
            >
              <Col>
                <Row>
                  <Col className="headerMenu">
                    <Icon
                      type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                      className="collapse-icon"
                      onClick={this.toggle}
                    />
                    <Icon
                      type="bars"
                      className="menu-icon"
                    />
                  </Col>
                  <Col className="headerTitle">
                    <h2>{this.title}</h2>
                  </Col>
                </Row>
              </Col>
              <Col className="userProfile">
                <Dropdown
                  overlay={
                    <Menu>
                      <Menu.Item key="profile">
                        <Link to={`/admins/${this.props.user.id}`}>
                          <Icon className="mr-icon" type="profile" />
                          Profile
                        </Link>
                      </Menu.Item>
                      <Menu.Item key="logout">
                        <div onClick={this.props.logout}>
                          <Icon className="mr-icon" type="logout" />
                          Log out
                        </div>
                      </Menu.Item>
                    </Menu>
                  }
                  placement="bottomCenter"
                >
                  <div style={this.styles.divMenu}>
                    <Icon style={this.styles.menuIcon} type="user" />
                    <span>
                      {this.props.user.full_name}
                    </span>
                  </div>
                </Dropdown>
              </Col>
            </Row>
          </Header>
          <Content className="content">
            {/* eslint-disable-next-line react/prop-types */}
            {this.props.children}
          </Content>
        </Layout>
      </Layout>
    );
  }
}

export default withRouter(connect(state => state.auth, { logout })(MainLayout));



// WEBPACK FOOTER //
// ./src/containers/Layout/index.js